import React, { useEffect } from "react";

import LOGO from "../../assets/GRF_TM.png";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    console.log(script, "script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    // script.onload = display.Razorpay;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

function Payment({ orderId, amountDue, confirmPurchase, user = {} }) {
  useEffect(() => {
    displayRazorPay(orderId, amountDue);
  }, [orderId]);

  async function displayRazorPay(order_id, amount_due) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("razorpay sdk failed to load. Are you online?");
      return;
    }
    const options = {
      // key: "rzp_live_sQUKmRdJvQfR7J",
      key: "rzp_test_sK3N3BmNdCpnVj",
      amount: amount_due,
      currency: "INR",
      name: "GRF",
      description: "Service payment",
      image: LOGO,
      order_id: `${order_id}`,
      // "callback_url":"www.google.com",
      // "redirect": true,
      handler: function (response) {
        confirmPurchase(
          response.razorpay_order_id,
          response.razorpay_payment_id,
          response.razorpay_signature
        );
      },
      prefill: {
        name: user.first_name + user.last_name,
        email: user.email,
        contact: user.phone.slice(2, 12)
      },
    };
    var paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  return <React.Fragment></React.Fragment>;
}

export default Payment;
